export default __webpack_public_path__ + "static/media/available-soon.6d42795e.png";